import { SHOW_IDENTIFIER } from "./constants";

// eslint-disable-next-line import/no-anonymous-default-export
export default {
  [SHOW_IDENTIFIER]: false,
};
